// import { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

// import ModalViewPDF from 'components/UI/ModalViewPDF/ModalViewPDF';

import classes from './SummaryIcon.module.css';

const SummaryIcon = props => {
  const { t } = useTranslation(['course']);
  // const [openSummary, setOpenSummary] = useState(false);

  const summaryHandler = () => {
    window.open(props.summary);
    // setOpenSummary(!openSummary);
  };

  return (
    <>
      <Tooltip placement="bottom" title={t('summary')}>
        <IconButton
          className={classes.summaryBtn}
          onClick={summaryHandler}
        >
          <figure className={classes.summaryImg}>
            <img
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/icon_Resumen.png"
              className={classes.img}
            />
          </figure>
        </IconButton>
      </Tooltip>

      {/* {openSummary && (
        <ModalViewPDF
          urlCloudFront={props.summary}
          openModal={openSummary}
          onCloseModal={summaryHandler}
          urlViewPDF={props.summary}
          titlePDF={t('summary')}
          summary
        />
      )} */}
    </>
  );
};

SummaryIcon.propTypes = {
  // eslint-disable-next-line react/require-default-props
  summary: PropTypes.string
};

export default SummaryIcon;
